<div class="main-content side-content pt-0 ml-0">
    <div class="main-container container-fluid">
      <div class="inner-body">
        <div class="row row-sm add-form">
          <div class="col-lg-12 col-md-12">
            <div class="card custom-card">
              <div class="card-body pb-0">
                <div class="col-md-12 prpl">
                  <div class="row align-items-center mb-3">
                    <div class="col-md-10">
                      <div class="d-flex align-items-center">
                        <img alt="Logo" src="../../assets/img/attendance.png" class="mh-45px pb-2" />
                        <p class="mb-1 ml-3">
                          <span class="main-content-label f600"><b>Theory Exam Appointment</b></span><br />
                          <span class="text-muted card-sub-title mb-0">Schedule and Manage Theory Exam Appointments</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr class="mt-2" />

                  <form [formGroup]="TheoryExamForm" autocomplete="off">
                    <!-- Filters Row 1 -->
                    <div class="row clearfix mt-2">
                      <!-- Session Dropdown -->
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Session</mat-label>
                            <mat-select #selectSession formControlName="SessionId"
                              (selectionChange)="onSessionChange($event.value)">
                              <mat-select-filter *ngIf="selectSession.focused" [placeholder]="'Filter'"
                                [displayMember]="'SnName'" [array]="sessionList"
                                (filteredReturn)="SessionFilterList = $event">
                              </mat-select-filter>
                              <mat-option *ngFor="let item of SessionFilterList" [value]="item.SnNo">
                                {{ item.SnName }}
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="f.SessionId.hasError('required')">Session is required</mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Faculty Dropdown -->

                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Faculty</mat-label>
                            <mat-select #selectFaculty formControlName="FacultyId" multiple
                              (selectionChange)="onFacultyChange($event.value)">
                              <mat-select-filter *ngIf="selectFaculty.focused" [placeholder]="'Filter'"
                                [displayMember]="'FcDesc'" [array]="facultyList"
                                (filteredReturn)="filteredFacultyList = $event">
                              </mat-select-filter>
                              <mat-option [value]="'selectAll'" style="font-weight: bold; border-bottom: 1px solid #ccc;">
                                Select All
                              </mat-option>
                              <mat-option *ngFor="let item of filteredFacultyList" [value]="item.FcCode">
                                {{ item.FcCode }} - {{ item.FcDesc }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Course Level Dropdown (MULTI-SELECT + SELECT ALL) -->
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Course Level</mat-label>
                            <mat-select #selectCourseLevel formControlName="CourseLevel" multiple
                              (selectionChange)="onCourseLevelChange($event.value)">
                              <mat-select-filter *ngIf="selectCourseLevel.focused" [placeholder]="'Filter'"
                                [displayMember]="'CdDesc'" [array]="courseLevelList"
                                (filteredReturn)="filteredCourseLevelList = $event">
                              </mat-select-filter>
                              <!-- Select All option -->
                              <mat-option [value]="'selectAll'" style="font-weight: bold; border-bottom: 1px solid #ccc;">
                                Select All
                              </mat-option>
                              <mat-option *ngFor="let item of filteredCourseLevelList" [value]="item.CdCode">
                                {{ item.CdDesc }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Course Dropdown -->
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Course</mat-label>
                            <mat-select formControlName="Course" multiple (selectionChange)="onCourseChange($event.value)">
                              <!-- Select All option -->
                              <mat-option [value]="'selectAll'" style="font-weight: bold; border-bottom: 1px solid #ccc;">
                                Select All
                              </mat-option>
                              <mat-option *ngIf="filteredCourseList.length === 0" disabled>
                                No courses available
                              </mat-option>
                              <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCgCoCode">
                                {{ item.CoCgCoCode }} - {{ item.CoName }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Exam Dropdown -->
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Exam</mat-label>
                            <mat-select formControlName="Exam" multiple (selectionChange)="onExamChange($event.value)">
                              <!-- Select All option -->
                              <mat-option [value]="'selectAll'" style="font-weight: bold; border-bottom: 1px solid #ccc;">
                                Select All
                              </mat-option>
                              <mat-option *ngIf="filteredExamList.length === 0" disabled>
                                No exams available
                              </mat-option>
                              <mat-option *ngFor="let item of filteredExamList" [value]="item.EmId">
                                {{ item.EmCoCode }} - {{ item.EmName }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Center (College) Dropdown -->
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Center</mat-label>
                            <mat-select #selectCenter formControlName="Center"
                              (selectionChange)="onCenterChange($event.value)">
                              <mat-select-filter *ngIf="selectCenter.focused" [placeholder]="'Filter'"
                                [displayMember]="'CgName'" [array]="collegeList"
                                (filteredReturn)="filteredCollegeList = $event">
                              </mat-select-filter>
                              <mat-option *ngFor="let item of filteredCollegeList" [value]="item.CgCode">
                              {{ item.CgCode }} - {{ item.CgName }} ({{ item.DistrictName }})
                              </mat-option>
                            </mat-select>
                            <mat-error *ngIf="f.Center.hasError('required')">Center is required</mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>

                    <!-- Filters Row 2 -->
                    <div class="row clearfix">
                      <!-- From Date -->
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>From Date</mat-label>
                            <input matInput [matDatepicker]="fromDatePicker" formControlName="FromDate"
                              [min]="minExamDate" [max]="maxExamDate" (dateChange)="onFromDateChange()"
                              placeholder="DD/MM/YYYY" />
                            <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #fromDatePicker></mat-datepicker>
                            <mat-error *ngIf="f.FromDate.hasError('required')">From Date is required</mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- To Date -->
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>To Date</mat-label>
                            <input matInput [matDatepicker]="toDatePicker" formControlName="ToDate" [min]="minExamDate"
                              [max]="maxExamDate" (dateChange)="onToDateChange()" placeholder="DD/MM/YYYY" />
                            <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #toDatePicker></mat-datepicker>
                            <mat-error *ngIf="f.ToDate.hasError('required')">To Date is required</mat-error>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Role Dropdown -->
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Role</mat-label>
                            <mat-select #selectRole formControlName="Role" (selectionChange)="onRoleChange($event.value)">
                              <mat-select-filter *ngIf="selectRole.focused" [placeholder]="'Filter'"
                                [displayMember]="'CdDesc'" [array]="roleList"
                                (filteredReturn)="filteredRoleList = $event">
                              </mat-select-filter>
                              <mat-option *ngFor="let item of filteredRoleList" [value]="item.CdCode">
                                {{ item.CdDesc }}
                              </mat-option>
                            </mat-select>

                            <!-- Dynamic hints based on role -->
                            <mat-hint *ngIf="TheoryExamForm.get('Role').value === 'CO'" class="text-info">
                              <i class="fas fa-info-circle"></i> CO must be from a
                              different college
                            </mat-hint>
                            <mat-hint *ngIf="TheoryExamForm.get('Role').value === 'CI'" class="text-info">
                              <i class="fas fa-info-circle"></i> CI must be from
                              the same college
                            </mat-hint>
                            <mat-hint *ngIf="TheoryExamForm.get('Role').value === 'INV'" class="text-info">
                              <i class="fas fa-info-circle"></i> Invigilator must
                              be from the same college
                            </mat-hint>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Teacher Dropdown -->            
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Teacher</mat-label>
                            <mat-select #selectTeacher formControlName="Teacher" (selectionChange)="onTeacherChange($event.value)">
                              
                              <mat-select-filter 
                                *ngIf="selectTeacher.focused" 
                                [placeholder]="'Search Teacher...'" 
                                [displayMember]="'displayName'" 
                                [array]="teacherList" 
                                [debounceTime]="300" 
                                (filteredReturn)="filteredTeacherList = $event.slice(0, 100)">
                              </mat-select-filter>

                              <mat-option *ngIf="isLoadingTeachers" disabled>
                                <i class="fas fa-spinner fa-spin"></i> Loading teachers...
                              </mat-option>

                              <mat-option *ngIf="!isLoadingTeachers && filteredTeacherList.length === 0" disabled>
                                No teachers available for this role
                              </mat-option>

                              <mat-option 
                                *ngFor="let item of filteredTeacherList; trackBy: trackTeacherById" 
                                [value]="item.TechId" 
                                [style.color]="item.isAssigned ? '#28a745' : '#6c757d'"
                                [style.fontWeight]="item.isAssigned ? '500' : 'normal'">
                                <span>
                                  <ng-container *ngIf="item.genderSuffix === 'M'">
                                    {{ item.displayNameWithoutGender }}
                                    <span style="color: #2196f3; font-weight: 500"> - M</span>
                                  </ng-container>
                                  <ng-container *ngIf="item.genderSuffix === 'F'">
                                    {{ item.displayNameWithoutGender }}
                                    <span style="color: #e91e63; font-weight: 500"> - F</span>
                                  </ng-container>
                                  <ng-container *ngIf="!item.genderSuffix">
                                    {{ item.displayName }}
                                  </ng-container>
                                </span>
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <!-- Radio Buttons for Appointment Type -->
                      <div class="col-sm-2 col-md-2 col-lg-2 xyz">
                        <div class="form-group">
                          <label class="d-block">Appointment Type :</label>
                          <mat-radio-group formControlName="ApptType" class="d-flex" (change)="onApptTypeChange()">
                            <mat-radio-button value="R" class="mr-3">Regular</mat-radio-button>
                            <mat-radio-button value="X">Emergency Replacement</mat-radio-button>
                          </mat-radio-group>
                        </div>
                      </div>
                    </div>
                  </form>

                  <!-- Action Buttons -->
                  <div class="col-sm-12 mt-4 mb-3">
                    <div class="floatright">
                      <button type="button" class="btn size1 btn-primary btn-icon-text mr-3" (click)="onSave()"
                        [disabled]="!TheoryExamForm.valid || isFinalSubmitted">
                        <i class="fas fa-save"></i>
                        <span class="ml-1">Save</span>
                      </button>
                      <button type="button" class="btn size1 btn-primary btn-icon-text mr-3" (click)="onList()"
                        [disabled]="!Table">
                        <i class="fas fa-list"></i>
                        <span class="ml-1">List</span>
                      </button>
                      <button type="button" class="btn size1 btn-primary btn-icon-text mr-3" (click)="onDownload()"
                        [disabled]="!Table">
                        <i class="fas fa-download"></i>
                        <span class="ml-1">Download</span>
                      </button>
                    <button type="button" class="btn size1 btn-primary btn-icon-text mr-3" 
                      (click)="bulkSendOrders()"
                      [disabled]="selectedAppointments.length === 0 || isFinalSubmitted">
                      <i class="fas fa-paper-plane"></i>
                      <span class="ml-1">Send Appointments ({{ selectedAppointments.length }})</span>
                    </button>
                    <button type="button" class="btn size1 btn-primary btn-icon-text" (click)="onClear()">
                      <i class="fas fa-undo-alt"></i>
                      <span class="ml-1">Clear</span>
                    </button>
                  </div>
                </div>

                  <hr class="mt-3" />

                  <!-- Results Table -->

                  <!-- Teacher List Table -->

                <div *ngIf="Table" class="table-responsive mt-4">
                  <div class="container-fluid pl-pr">
                    <table class="table table-bordered text-center">
                      <thead class="text-center">
                        <tr>
                          <th style="min-width: 40px;">
                            <input type="checkbox" 
                                   (change)="toggleSelectAll($event)"
                                   [checked]="isAllSelected()"
                                   [disabled]="isFinalSubmitted">
                          </th>
                            <th style="min-width: 200px">Teacher Name</th>
                            <th style="min-width: 150px">Role</th>
                            <th style="min-width: 120px">From Date</th>
                            <th style="min-width: 120px">To Date</th>
                            <th style="min-width: 150px">Session</th>
                            <th style="min-width: 150px">Faculty</th>
                            <th style="min-width: 120px">Course Level</th>
                            <th style="min-width: 150px">Course</th>
                            <th style="min-width: 150px">Exam</th>
                            <th style="min-width: 150px">Center</th>
                            <th style="min-width: 100px">Appointment Type</th>
                            <th style="min-width: 220px">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let item of teacherAppointments; let i = index"
                            [ngClass]="{'locked-row': item.IsSendOrder === true || item.IsSendOrder === 1}">
                          <td>
                           <ng-container *ngIf="item.IsSendOrder === 1 || item.IsSendOrder === true; else checkboxTemplate">
                          <span style=" color: #232121; font-size: 12px; padding: 4px 8px; border-radius: 4px;">
                            <i class="fas fa-check-circle"></i> Sent
                          </span>
                        </ng-container>
                            <ng-template #checkboxTemplate>
                              <input type="checkbox" 
                                     [checked]="isSelected(item)"
                                     (change)="toggleSelection(item)"
                                     [disabled]="isFinalSubmitted || item.IsFinalSubmit === 1 || item.IsSendOrder">
                            </ng-template>
                          </td>
                            <td class="tdleft">{{ item.TeacherName }}</td>
                            <td class="tdleft">
                              <ng-container *ngIf="item.RoleCode === 'INV'">
                                <span *ngIf="getSquadNumber(item.TechId)">
                                  Internal Vigilance Squad-{{ getSquadNumber(item.TechId) }}
                                </span>
                                <span *ngIf="!getSquadNumber(item.TechId)">
                                  {{ item.RoleName || item.RoleCode }}
                                </span>
                              </ng-container>
                              <ng-container *ngIf="item.RoleCode !== 'INV'">
                                {{ item.RoleName || item.RoleCode }}
                              </ng-container>
                            </td>
                            <td class="tdleft">{{ item.FromDate || "-" }}</td>
                            <td class="tdleft">{{ item.ToDate || "-" }}</td>
                            <td class="tdleft">{{ item.SessionName }}</td>
                            <td class="tdleft">{{ item.FacultyName }}</td>
                            <td class="tdleft">{{ item.CourseLevel || "-" }}</td>
                            <td class="tdleft">{{ item.CourseName || "-"}}</td>
                            <td class="tdleft">{{ item.ExamName || "-"}}</td>
                            <td class="tdleft">{{ item.CenterName }}</td>
                            <td>
                              <span *ngIf="item.ApptType === 'R'">Regular</span>
                              <span *ngIf="item.ApptType === 'X'">Replacement</span>
                              <span *ngIf="!item.ApptType">-</span>
                            </td>
                            <td class="tdleft">
                              <div class="d-flex justify-content-center gap-2 flex-wrap" style="gap: 8px">
                                <button type="button" class="floating" (click)="onEditAppointment(item, i)" title="Edit"
                                  [disabled]="isFinalSubmitted || item.IsFinalSubmit === 1 || item.IsSendOrder">
                                  <i class="fas fa-edit"></i>
                                </button>
                                <button type="button" class="floating" (click)="onDeleteAppointment(item, i)"
                                  title="Delete"
                                  [disabled]="isFinalSubmitted || item.IsFinalSubmit === 1 || item.IsSendOrder">
                                  <i class="fas fa-trash-alt"></i>
                                </button>
                                <button type="button" class="floating" (click)="onSendOrder(item, i)" title="Send Order"
                                  [disabled]="isFinalSubmitted || item.IsFinalSubmit === 1 || item.IsSendOrder">
                                  <i class="fas fa-lock"></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        <tr *ngIf="teacherAppointments.length === 0">
                          <td colspan="13" class="text-center">
                            <i class="fas fa-info-circle mr-2"></i>
                              No appointments yet. Click Save to create.
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <!-- Final Submit Button-->
                  <!-- <div *ngIf="Table && teacherAppointments.length > 0" class="row mt-4 mb-3">
                    <div class="col-12 text-center">
                      <button type="button" class="btn btn-primary btn-lg" (click)="onFinalSubmit()"
                        [disabled]="isFinalSubmitted">
                        <i class="fas fa-lock"></i>
                        <span class="ml-2">Send Order</span>
                      </button>
                      <small *ngIf="isFinalSubmitted" class="text-success d-block mt-2">
                        <i class="fas fa-lock"></i> Form is finalized. No more additions or edits or deletions
                        allowed.
                      </small>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>